import { escapeRegExp } from '@/lib/functions/other';
import union from 'lodash.union';
import { VersionItem, VersionValidatorItem } from 'store';

export const fuzzyFilter = (searchedValue: string) => (field: string) => (element: Record<string, any>) => {
	if (element[field] === undefined) {
		return false;
	}

	let filtered = [];

	const escaped = escapeRegExp(searchedValue);
	// eslint-disable-next-line no-useless-escape
	const valuesBlackListReg = /[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g;

	const exactSearch = new RegExp('^' + escaped + '$', 'i');
	const firstSearch = new RegExp('^' + escaped, 'i');
	const looseSearch = new RegExp('.*' + escaped + '.*', 'i');
	const fuzzySearch = new RegExp(
		'(^' +
			escaped +
			')|(' +
			escaped +
			')|(' +
			escapeRegExp(
				searchedValue
					.replace(/\s+/g, '')
					.split('')
					.join('.*')
			) +
			')',
		'i'
	);

	if (searchedValue === '') {
		filtered.push(element);
	} else if (!valuesBlackListReg.test(searchedValue)) {
		const label = field ? element[field] : element;
		const exact = [];
		const first = [];
		const loose = [];
		const fuzzy = [];

		const textWithoutPolishSigns = label
			.replace(/ę/gi, 'e')
			.replace(/ó/gi, 'o')
			.replace(/ą/gi, 'a')
			.replace(/ś/gi, 's')
			.replace(/ł/gi, 'l')
			.replace(/ż/gi, 'z')
			.replace(/ź/gi, 'z')
			.replace(/ć/gi, 'c')
			.replace(/ń/gi, 'n');

		if (label.match(exactSearch) || textWithoutPolishSigns.match(exactSearch)) {
			exact.push(element);
		}

		if (label.match(firstSearch) || textWithoutPolishSigns.match(firstSearch)) {
			first.push(element);
		}

		if (label.match(looseSearch) || textWithoutPolishSigns.match(looseSearch)) {
			loose.push(element);
		}

		if (label.match(fuzzySearch) || textWithoutPolishSigns.match(fuzzySearch)) {
			fuzzy.push(element);
		}

		filtered = union(exact, first, loose, fuzzy);
	}

	return filtered.length ? false : true;
};

export const filterVersion = (version: VersionItem) => (item: VersionValidatorItem) => {
	const currVer = version.value;
	const versionFrom = item.versionFrom ? parseInt(item.versionFrom.split('.').join(''), 10) : 0;
	const versionTo = item.versionTo ? parseInt(item.versionTo.split('.').join(''), 10) : 0;

	return !((currVer >= versionFrom || !versionFrom) && (currVer <= versionTo || !versionTo));
};
